module.exports = __webpack_public_path__ + "static/media/contact-us-icon.4e8f52f0.svg";